import * as React from 'react';
import debounce from 'lodash/debounce';

import { IRegion } from '../../../types';

import { searchCitiesRegions } from './search_cities_regions';

import { Suggest, ISuggestItem } from './suggest';

export interface IGeoSuggestProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelect(geoItem: IRegion): any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSearchChange?(value: string): any;
  selected?: IRegion;
  className?: string;
}

interface IGeoSuggestState {
  loading: boolean;
  suggestions: ISuggestItem<IRegion>[] | null;
}

export class GeoSuggest extends React.Component<IGeoSuggestProps, IGeoSuggestState> {
  private suggest: Suggest | null = null;

  private fetchSuggestions = debounce(async value => {
    const suggestions = await searchCitiesRegions(value)
      .then(response => {
        if (response.statusCode !== 200) {
          throw response.response.errors;
        }

        return (response.response.data.items || []).map(geoItem => ({
          title: geoItem.displayName,
          value: geoItem,
        }));
      })
      .catch(() => null);

    this.setState({
      loading: false,
      suggestions,
    });
  }, 300);

  public constructor(props: IGeoSuggestProps) {
    super(props);

    this.state = {
      loading: false,
      suggestions: null,
    };
  }

  public componentDidUpdate(prevProps: IGeoSuggestProps) {
    const { selected } = this.props;

    if (selected && selected !== prevProps.selected) {
      this.handleSetSuggestValue(selected.displayName);
    }
  }

  public render() {
    return (
      <Suggest
        ref={ref => {
          this.suggest = ref;
        }}
        className={this.props.className}
        placeholder="Введите регион или город"
        onValueChange={this.handleSearchChange}
        loading={this.state.loading}
        suggestions={this.state.suggestions}
        onSelect={this.handleSelect}
        onBlur={this.handleBlur}
      />
    );
  }

  private handleSetSuggestValue = (value: string) => {
    if (this.suggest) {
      this.suggest.setValue(value);
    }
  };

  private handleSelect = (item: ISuggestItem<IRegion>) => {
    this.props.onSelect(item.value);
  };

  private handleSearchChange = (value: string) => {
    if (value.length > 2) {
      this.setState({
        loading: true,
      });

      this.fetchSuggestions(value);
    } else {
      this.setState({
        loading: false,
        suggestions: null,
      });
    }

    if (this.props.onSearchChange) {
      this.props.onSearchChange(value);
    }
  };

  private handleBlur = () => {
    const { selected } = this.props;

    if (selected) {
      this.handleSetSuggestValue(selected.displayName);
    }
  };
}
